module.exports = "<div class=\"kl-tooltip kl-tooltip--{placement} animated {class}\" r-hide=\"{!isShow}\" r-animation=\"on:enter;class:fadeInY;on:leave;class:fadeOutY\">\n\t<div class=\"kl-tooltip__arrow\"></div>\n\t<p class=\"kl-tooltip__inner\">{#inc tip}</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/widget/KLTooltip/index.html
// module id = 532
// module chunks = 0